import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CorporateCsrService } from 'src/app/shared/services/corporate/corporate-csr/corporate-csr.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage/local-storage.service';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-csr-dashboard',
  templateUrl: './csr-dashboard.component.html',
  styleUrl: './csr-dashboard.component.scss',
})
export class CsrDashboardComponent {
  public queryParams: any = null;
  public activeTab: number = 1;
  public donationSummary: any = null;
  public selectedChart = 'bar-chart';
  public lineChartDays = '30 Days';
  public lineChartData = [];
  public selectedPeriod = 'last15Days'; // Default selection
  public donations = [];
  public campaign_id: string = null;
  public ngoCampaignId: string = null;
  public fromPreviousPage: string = null;

  public row2 = [
    {
      carts_icon: './assets/images/icon/matching_budget.svg',
      carts_name: 'Total Donation',
      carts_description: 'Total donation by employees',
      isAmount: true,
      calculated_data: null,
    },
    {
      carts_icon: './assets/images/icon/funds_matched.svg',
      carts_name: 'Funds Matched',
      carts_description: 'Total funds matched by company',
      isAmount: true,
      calculated_data: null,
    },
    {
      carts_icon: './assets/images/icon/matching_limit.svg',
      carts_name: 'Remaining Budget',
      carts_description: 'Remaining budget to match by company',
      isAmount: true,
      calculated_data: null,
    },
    {
      carts_icon: './assets/images/icon/participating_rate.svg',
      carts_name: 'Total Donation',
      carts_description: 'No of donation employees have donated',
      isAmount: false,
      calculated_data: null,
    },
  ];
  public row1 = [
    {
      carts_icon: './assets/images/icon/participating_employee.svg',
      carts_name: 'Total Collected',
      carts_description: 'Total amount donated to the cause',
      isAmount: true,
      calculated_data: null,
    },
    {
      carts_icon: './assets/images/icon/total_collected.svg',
      carts_name: 'Matching Limit',
      carts_description: 'Matching limit per employee',
      isAmount: true,
      calculated_data: null,
    },
    {
      carts_icon: './assets/images/icon/matching_percentage.svg',
      carts_name: 'Matching Percentage',
      carts_description: 'matching percentage of company',
      isAmount: false,
      calculated_data: null,
    },
  ];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService,
    private readonly corporateCrsService: CorporateCsrService,
    private readonly router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const encryptedString = params['data'];
      this.queryParams =
        this.localStorageService.decryptObjectUrl(encryptedString);

      if (this.queryParams) {
        console.log('lol2', this.queryParams);
        this.ngoCampaignId = this.queryParams?.ngo_campaign_id;
        this.fromPreviousPage = this.queryParams?.previousPage;
        this.getDashboardSummary();
        this.getCampaignAnalytics(15);
        // this.getEmployeeParticipating(15);
      }
    });
  }

  get getCurrentUrl(): string {
    const currentUrl = this.router.url.split('/')[1];
    return currentUrl;
  }

  public getDashboardSummary() {
    this.corporateCrsService
      .getDashboardSummary(
        this.queryParams?.company_id,
        this.queryParams?.campaign_id
      )
      .subscribe({
        next: (result) => {
          this.row2[0].calculated_data = result.total_collected;
          this.row2[1].calculated_data = result.matched_amount;
          this.row2[2].calculated_data = result.remaining_budget;
          this.row2[3].calculated_data = result.donation_count;
          this.row1[0].calculated_data = result.total_collection;
          this.row1[1].calculated_data = result.matching_limit_per_employee;
          this.row1[2].calculated_data = result.matching_percentage;
          this.donationSummary = result.recent_donations;
        },
      });
  }

  public openReceipt(receipt): void {
    const receiptUrl = this.utilitiesService.jsonParse(receipt)?.url;
    window.open(receiptUrl, 'blank');
  }

  public onChartChange(e: any) {
    this.selectedChart = e.value;
  }

  public onTimePeriodChange(event: any): void {
    this.selectedPeriod = event.value;
    if (this.selectedPeriod === 'last15Days') {
      this.getCampaignAnalytics(15);
      // this.getEmployeeParticipating(15);
      this.lineChartDays = '15 Days';
    } else if (this.selectedPeriod === 'lastWeek') {
      this.getCampaignAnalytics(7);
      // this.getEmployeeParticipating(7);
      this.lineChartDays = '7 Days';
    } else {
      this.getCampaignAnalytics(30);
      // this.getEmployeeParticipating(30);
      this.lineChartDays = '30 Days';
    }
  }

  public getCampaignAnalytics(last_date: number) {
    this.corporateCrsService
      .getDonationAnalytics(this.ngoCampaignId, last_date)
      .subscribe({
        next: (result) => {
          this.donations = [...this.formatDates(result)];
          this.lineChartData = this.donations;
          this.cdr.detectChanges();
        },
      });
  }

  public getEmployeeParticipating(last_date: number) {
    this.corporateCrsService
      .getDonationAnalytics(this.ngoCampaignId, last_date)
      .subscribe({
        next: (result) => {
          this.lineChartData = [...this.formatDates(result)];
          this.cdr.detectChanges();
        },
      });
  }

  private formatDates(donations: any[]): any[] {
    return donations.map((donation) => {
      return {
        ...donation,
        formattedDate: this.convertDate(donation.day),
      };
    });
  }

  private convertDate(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
    };
    return date.toLocaleDateString('en-US', options);
  }

  public setDate(daysBefore: number): string {
    const date = new Date();
    date.setDate(date.getDate() - daysBefore);
    return date.toISOString();
  }

  get getTotalEmployees(): number {
    return (
      this.lineChartData?.reduce(
        (sum, item) => sum + (item.total_employee || 0),
        0
      ) || 0
    );
  }

  get getTotalAmount(): number {
    return (
      this.donations?.reduce(
        (sum, item) => sum + (item.total_amount || 0),
        0
      ) || 0
    );
  }
}
